import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "transactions" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src", "onError"];
const _hoisted_5 = { class: "merchant-name" };
const _hoisted_6 = { class: "category" };
const _hoisted_7 = {
    key: 3,
    class: "tags"
};
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { class: "moneyIn" };
const _hoisted_11 = {
    key: 2,
    class: "voucher-available"
};
const _hoisted_12 = {
    key: 3,
    class: "excluded-icon"
};
const _hoisted_13 = {
    key: 1,
    class: "centered small"
};
const _hoisted_14 = {
    key: 2,
    class: "load-more-wrap"
};
const _hoisted_15 = ["src"];
import { ref, computed, onMounted, onUnmounted, getCurrentInstance, watch } from 'vue';
import { getBrandLogoUrl, getCategoryIconUrl } from '@/utils/helpers';
import MGTextField from './MGTextField.vue';
import MGButton from './MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionsList',
    props: {
        search: { type: Boolean, default: false },
        transactions: {},
        formatter: {},
        today: {},
        yesterday: {},
        showDate: { type: Boolean, default: true },
        showDateTotal: { type: Boolean, default: false },
        emptyDescription: { default: null },
        allowSearchBack: { type: Boolean, default: false },
        dividingLines: { type: Boolean, default: false },
        dateCounts: { default: () => ({}) },
        hideEmptyDescription: { type: Boolean, default: false },
        updatingTransactionId: { default: null },
        onTransactionClick: { type: [Function, null], default: null },
        categoryPills: { type: Boolean, default: false },
        selectable: { type: Boolean, default: false },
        selectedIds: { default: () => new Set() },
        initialLimit: { default: undefined }
    },
    emits: ["refreshTransaction", "cleared", "searchBack"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const wellKnownLogosOnly = instance?.appContext.config.globalProperties.$wellKnownLogosOnly;
        const query = ref("");
        const hide = ref([]);
        const context = ref(false);
        const doShowDate = ref(true);
        const empDesc = ref("There are no transactions to show. Offline accounts do not have transaction data, and newly added online accounts may take up to 5 minutes to show transactions.");
        const clickedTransaction = ref(null);
        const transactionUpdating = ref(false);
        const showModal = ref(false);
        const searchedTransactions = computed(() => {
            var ret = [];
            if (query.value) {
                var q = query.value.trim().toLowerCase();
                var friendlyAmount = query.value;
                if (friendlyAmount.includes('.') && friendlyAmount.endsWith('0')) {
                    friendlyAmount = friendlyAmount.substring(0, friendlyAmount.length - 1);
                    console.log(friendlyAmount);
                }
                props.transactions.forEach(g => {
                    var ts = [];
                    g.forEach((t) => {
                        if (t.merchantName.toLowerCase().includes(q)
                            || ((t.effectiveClassification.mgClassification && t.effectiveClassification.mgClassification.toLowerCase() + (t.excludeFromAnalysis ? ' (excluded)' : '')).includes(q))
                            || (t.amount.toString().includes(friendlyAmount))
                            || (t.customerTags && t.customerTags.some((tag) => tag.tag.toLowerCase().includes(q)))) {
                            ts.push(t);
                        }
                    });
                    if (ts.length > 0) {
                        ret = [...ret, ts];
                    }
                });
                return ret;
            }
            else {
                props.transactions.forEach(g => {
                    var ts = [];
                    g.forEach((t) => {
                        if (!hide.value.includes(t.merchantName.toLowerCase())) {
                            ts.push(t);
                        }
                    });
                    if (ts.length > 0) {
                        ret = [...ret, ts];
                    }
                });
                return ret;
            }
        });
        const visibleLimit = ref(props.initialLimit ?? 0);
        // Cap rendered rows when `initialLimit` is set and the user isn't searching.
        // Searches always run against the full dataset so results can't be hidden
        // behind the cap.
        const limitedTransactions = computed(() => {
            const list = searchedTransactions.value;
            if (query.value || !props.initialLimit)
                return list;
            const limit = visibleLimit.value;
            const out = [];
            let count = 0;
            for (const g of list) {
                if (count >= limit)
                    break;
                const remaining = limit - count;
                if (g.length <= remaining) {
                    out.push(g);
                    count += g.length;
                }
                else {
                    out.push(g.slice(0, remaining));
                    count = limit;
                    break;
                }
            }
            return out;
        });
        const totalRowCount = computed(() => searchedTransactions.value.reduce((s, g) => s + g.length, 0));
        const visibleRowCount = computed(() => limitedTransactions.value.reduce((s, g) => s + g.length, 0));
        const hasMore = computed(() => !query.value && !!props.initialLimit && visibleRowCount.value < totalRowCount.value);
        function loadMore() {
            if (props.initialLimit)
                visibleLimit.value += props.initialLimit;
        }
        watch(() => props.transactions, () => {
            if (props.initialLimit)
                visibleLimit.value = props.initialLimit;
        });
        function onLoad() {
            if (props.showDate != null && !props.showDate) {
                doShowDate.value = false;
            }
            if (props.emptyDescription != null) {
                empDesc.value = props.emptyDescription;
            }
        }
        function searchBack() {
            emit('searchBack', query.value);
        }
        function searchTransactions(q) {
            query.value = q;
        }
        function navigateToTransaction(transaction) {
            if (props.onTransactionClick) {
                props.onTransactionClick(transaction);
                return;
            }
            clickedTransaction.value = transaction;
            showModal.value = true;
        }
        function refreshSelectedTransaction() {
            if (clickedTransaction.value) {
                emit('refreshTransaction', clickedTransaction.value.id);
            }
        }
        const round3Path = require('@/assets/round3.png');
        function getClassificationIcon(t) {
            const classification = t.effectiveClassification || t.originalClassification;
            return getCategoryIconUrl(classification?.iconPath);
        }
        function classificationIconIsFallback(t) {
            return getClassificationIcon(t) === round3Path;
        }
        function getTransactionLogoUrl(t) {
            const wellKnown = localStorage.getItem('wellKnownLogosOnly') !== null
                ? localStorage.getItem('wellKnownLogosOnly') === 'true'
                : wellKnownLogosOnly;
            if (wellKnown) {
                const isKnown = !!t.merchant || t.wellKnownMerchant === true;
                if (!isKnown)
                    return getClassificationIcon(t);
            }
            else {
                if (t.amount >= 0) {
                    return require('@/assets/round1.png');
                }
            }
            return getBrandLogoUrl(t.merchant ? t.merchant.name : t.merchantName);
        }
        function isCategoryIconShown(t) {
            const wellKnown = localStorage.getItem('wellKnownLogosOnly') !== null
                ? localStorage.getItem('wellKnownLogosOnly') === 'true'
                : wellKnownLogosOnly;
            if (!wellKnown)
                return false;
            const isKnown = !!t.merchant || t.wellKnownMerchant === true;
            if (isKnown)
                return false;
            if (classificationIconIsFallback(t))
                return false;
            return true;
        }
        function handleLogoError(event, t) {
            event.target.src = getClassificationIcon(t);
        }
        // Tints the icon background with the category colour, so the white-on-transparent
        // category PNG fallback sits on its tree colour instead of the neutral grey.
        // Skipped for income (round1.png) and internal transfers (coins2.png), which
        // have their own bespoke icons — those keep the default grey.
        function getIconStyle(t) {
            const wellKnown = localStorage.getItem('wellKnownLogosOnly') !== null
                ? localStorage.getItem('wellKnownLogosOnly') === 'true'
                : wellKnownLogosOnly;
            if (!wellKnown) {
                if (t.amount >= 0)
                    return {};
            }
            else if (classificationIconIsFallback(t)) {
                return {};
            }
            const colour = t.effectiveClassification?.color;
            if (!colour)
                return {};
            const style = { backgroundColor: colour };
            return style;
        }
        function getCategoryColour(t) {
            return t.effectiveClassification?.color ?? '#9EA2D0';
        }
        function getCategoryPillStyle() {
            return { background: 'var(--background-color-grey-light)' };
        }
        function getCategoryDotStyle(t) {
            return { background: getCategoryColour(t) };
        }
        __expose({ searchTransactions });
        function onTransactionMessage(event) {
            if (event.data?.type === 'transactionUpdating') {
                transactionUpdating.value = event.data.value;
            }
        }
        onMounted(() => {
            onLoad();
            window.addEventListener('message', onTransactionMessage);
        });
        onUnmounted(() => {
            window.removeEventListener('message', onTransactionMessage);
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "transactions-list",
                    onClick: _cache[2] || (_cache[2] = event => { event.stopPropagation(); })
                }, [
                    (_ctx.search && (_ctx.transactions && _ctx.transactions.length > 0 || _ctx.allowSearchBack))
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "search-col" }, {
                                    default: _withCtx(() => [
                                        _createVNode(MGTextField, {
                                            modelValue: query.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((query).value = $event)),
                                            "prepend-inner-icon": "mdi-magnify",
                                            density: "compact",
                                            label: "Search transactions",
                                            variant: "solo",
                                            flat: true,
                                            "hide-details": "",
                                            clearable: "",
                                            "single-line": "",
                                            "onClick:clear": _cache[1] || (_cache[1] = ($event) => (emit('cleared'))),
                                            "bg-color": "#eeeeee"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (query.value && _ctx.transactions && _ctx.transactions.length > 0)
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "right" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("Total: " + _toDisplayString(_ctx.formatter.format(searchedTransactions.value.reduce((sum, group) => sum + group.reduce((groupSum, t) => groupSum + t.amount, 0), 0))), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_1, [
                        (_ctx.transactions && _ctx.transactions.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedTransactions.value, (g, gIndex) => {
                                    return (_openBlock(), _createElementBlock("div", { key: gIndex }, [
                                        (doShowDate.value)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 0,
                                                class: "mt-2 mb-2"
                                            }, {
                                                default: _withCtx(() => [
                                                    (g[0].timestampString != _ctx.today && g[0].timestampString != _ctx.yesterday)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 0,
                                                            class: "date-col"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(g[0].timestampString) + " (" + _toDisplayString(_ctx.dateCounts[g[0].timestampString] ?? g.length) + ")", 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024))
                                                        : _createCommentVNode("", true),
                                                    (g[0].timestampString == _ctx.today)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 1,
                                                            class: "date-col"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode("Today (" + _toDisplayString(_ctx.dateCounts[g[0].timestampString] ?? g.length) + ")", 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024))
                                                        : _createCommentVNode("", true),
                                                    (g[0].timestampString == _ctx.yesterday)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 2,
                                                            class: "date-col"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode("Yesterday (" + _toDisplayString(_ctx.dateCounts[g[0].timestampString] ?? g.length) + ")", 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024))
                                                        : _createCommentVNode("", true),
                                                    (_ctx.showDateTotal)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 3,
                                                            class: "dateTotal right"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.formatter.format(g.reduce((sum, t) => sum + t.amount, 0))), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1024))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g, (t) => {
                                            return (_openBlock(), _createBlock(_component_v_row, {
                                                class: _normalizeClass(["mb-1 transaction-row", { 'transaction-row-divider': _ctx.dividingLines }]),
                                                key: t.id,
                                                onClick: event => { event.stopPropagation(); navigateToTransaction(t); }
                                            }, {
                                                default: _withCtx(() => [
                                                    (_ctx.selectable)
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: _normalizeClass(["select-checkbox", { checked: _ctx.selectedIds && _ctx.selectedIds.has(t.id) }])
                                                        }, [
                                                            (_ctx.selectedIds && _ctx.selectedIds.has(t.id))
                                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                    key: 0,
                                                                    size: "12",
                                                                    color: "white"
                                                                }, {
                                                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                                        _createTextVNode("mdi-check")
                                                                    ])),
                                                                    _: 1
                                                                }))
                                                                : _createCommentVNode("", true)
                                                        ], 2))
                                                        : _createCommentVNode("", true),
                                                    _createVNode(_component_v_col, {
                                                        class: "v-col-2 icon-col",
                                                        style: {}
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (isCategoryIconShown(t))
                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                    key: 0,
                                                                    class: "icon category-icon-wrap",
                                                                    style: _normalizeStyle(getIconStyle(t))
                                                                }, [
                                                                    _createElementVNode("img", {
                                                                        class: "category-icon-img",
                                                                        src: getClassificationIcon(t),
                                                                        alt: ""
                                                                    }, null, 8, _hoisted_3)
                                                                ], 4))
                                                                : (_openBlock(), _createElementBlock("img", {
                                                                    key: 1,
                                                                    src: getTransactionLogoUrl(t),
                                                                    class: "icon",
                                                                    style: _normalizeStyle(getIconStyle(t)),
                                                                    onError: ($event) => (handleLogoError($event, t))
                                                                }, null, 44, _hoisted_4))
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                        class: _normalizeClass([t.availableVoucher ? 'v-col-6' : 'v-col-7', "details-col"])
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("span", _hoisted_5, _toDisplayString(t.merchant ? t.merchant.name : t.merchantName), 1),
                                                            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                                            (_ctx.updatingTransactionId === t.id)
                                                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                                    key: 0,
                                                                    size: 12,
                                                                    width: 2,
                                                                    indeterminate: "",
                                                                    class: "category-spinner"
                                                                }))
                                                                : (_ctx.categoryPills)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        _createElementVNode("span", {
                                                                            class: "category-pill",
                                                                            style: _normalizeStyle(getCategoryPillStyle())
                                                                        }, [
                                                                            _createElementVNode("span", {
                                                                                class: "category-dot",
                                                                                style: _normalizeStyle(getCategoryDotStyle(t))
                                                                            }, null, 4),
                                                                            _createTextVNode(" " + _toDisplayString((t.effectiveClassification.mgSubClassification || t.effectiveClassification.mgClassification)), 1)
                                                                        ], 4),
                                                                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1))
                                                                    ], 64))
                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                        _createElementVNode("span", _hoisted_6, _toDisplayString((t.effectiveClassification.mgSubClassification || t.effectiveClassification.mgClassification)), 1),
                                                                        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1))
                                                                    ], 64)),
                                                            (t.customerTags && t.customerTags.length > 0)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.customerTags, (tag) => {
                                                                        return (_openBlock(), _createElementBlock("span", {
                                                                            key: tag.id,
                                                                            class: "tag"
                                                                        }, " #" + _toDisplayString(tag.tag), 1));
                                                                    }), 128))
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["class"]),
                                                    (!context.value)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 1,
                                                            class: _normalizeClass([t.availableVoucher ? 'v-col-4' : 'v-col-3', "amount-col"])
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (t.amount < 0)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.formatter.format(t.amount * -1)), 1))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                                        _createElementVNode("span", _hoisted_10, "+" + _toDisplayString(_ctx.formatter.format(t.amount)), 1)
                                                                    ])),
                                                                (t.availableVoucher)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(t.availableVoucher.effectiveDiscountPercentage) + "% Voucher Available", 1))
                                                                    : _createCommentVNode("", true),
                                                                (t.excludeFromAnalysis)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                                        _createVNode(_component_v_icon, { icon: "mdi-poll" }),
                                                                        _cache[10] || (_cache[10] = _createTextVNode()),
                                                                        _createVNode(_component_v_icon, { icon: "mdi-eye-off-outline" })
                                                                    ]))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["class"]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1032, ["class", "onClick"]));
                                        }), 128)),
                                        (doShowDate.value && !_ctx.dividingLines)
                                            ? (_openBlock(), _createBlock(_component_v_divider, {
                                                key: 1,
                                                class: "mt-4"
                                            }))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true),
                        ((!_ctx.transactions || _ctx.transactions.length == 0) && !_ctx.hideEmptyDescription)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(empDesc.value), 1))
                            : _createCommentVNode("", true),
                        (hasMore.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(MGButton, {
                                    fullWidth: true,
                                    noCaps: true,
                                    outline: true,
                                    text: "Load more",
                                    onClick: loadMore
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.search && query.value && _ctx.allowSearchBack && query.value.length >= 3)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "centered mt-7",
                            onClick: searchBack
                        }, "Search Further Back"))
                        : _createCommentVNode("", true)
                ]),
                (clickedTransaction.value)
                    ? (_openBlock(), _createBlock(_component_v_dialog, {
                        key: 0,
                        class: "transactionDialogue",
                        transition: "dialog-bottom-transition",
                        fullscreen: "",
                        modelValue: showModal.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((showModal).value = $event)),
                        "onClick:outside": _cache[5] || (_cache[5] = ($event) => { showModal.value = false; refreshSelectedTransaction(); })
                    }, {
                        default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", {
                                class: "mg-circle-image-button",
                                style: _normalizeStyle('top:' + (15 + (parseInt(_unref(cookies)?.get('st') ?? '0'))) + 'px'),
                                onClick: _cache[3] || (_cache[3] = ($event) => { showModal.value = false; refreshSelectedTransaction(); })
                            }, [
                                _createVNode(_component_v_icon, { icon: "mdi-close" })
                            ], 4), [
                                [_vShow, !transactionUpdating.value]
                            ]),
                            _createElementVNode("iframe", {
                                src: '/#/transaction/' + clickedTransaction.value.id + '?inModal=true',
                                style: { "width": "100%", "height": "100%", "border": "none" }
                            }, null, 8, _hoisted_15)
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
